export default "__VITE_ASSET__BLZPxpDc__"